import { View } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { SelectServicePointsList } from "@repo/core/components/layout/SelectServicePointsList";
import { SelectServicePointController } from "./controller";

const SelectServicePoint = () => {
  const {
    isMobile,
    selectedServicePointId,
    servicePoints,
    handleOnSubmitForm,
    handleGoBack,
    handleSelectServicePoint,
    isFetchingServicePoints
  } = SelectServicePointController();

  return (
    <Scaffolds.Root
      minHeight="$100vh"
      title="Ponto de Atendimento"
      onBackPress={handleGoBack}
      showBackButtonOnWeb
    >
      <Scaffolds.Form
        showHeader={false}
        centerFormContent={false}
        footerContent={
          <View
            w="$full"
            gap="$4"
            flexDirection={!isMobile ? "row-reverse" : "column"}
            pt={isMobile ? "$4" : "$12"}
            px="$4"
            pb="$4"
            justifyContent="flex-end"
          >
            <Button
              size="xl"
              isDisabled={!selectedServicePointId}
              action={selectedServicePointId ? "primary" : "secondary"}
              text="Salvar"
              w="$full"
              onPress={handleOnSubmitForm}
            />
          </View>
        }
      >
        <View flex={1}>
          <SelectServicePointsList
            servicePoints={servicePoints}
            selectedServicePoint={selectedServicePointId}
            onSelectServicePoint={handleSelectServicePoint}
            isLoading={isFetchingServicePoints}
          />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};

export default SelectServicePoint;
